import { useState } from "react";
import { http } from "@/lib/api";
import { Check } from "lucide-react";
import { Link } from "react-router-dom";

export default function Partner() {
  const [form, setForm] = useState({ org_name: "", type: "doctor", specialty: "", city: "", phone: "", email: "", website: "", experience: "", message: "" });
  const [done, setDone] = useState(false);
  const set = (k,v) => setForm(f=>({...f,[k]:v}));
  const submit = async () => {
    try { await http.post("/partners", form); setDone(true); } catch(e){ alert("Failed"); }
  };
  if (done) return (
    <div className="max-w-2xl mx-auto px-6 py-24 text-center" data-testid="partner-success">
      <div className="w-16 h-16 rounded-full flex items-center justify-center mx-auto" style={{background:"linear-gradient(135deg,#B47A9A,#5E3A5C)"}}><Check className="w-7 h-7 text-white"/></div>
      <h1 className="font-serif text-4xl text-[#F3E9EC] mt-6">Thanks for your interest.</h1>
      <p className="mt-4 text-[#F3E9EC]/70">Our partnerships team will review your application and get back within 5–7 business days.</p>
      <Link to="/" className="btn-outline-mauve px-6 py-3 mt-8 inline-block">Return home</Link>
    </div>
  );
  return (
    <div className="max-w-3xl mx-auto px-6 py-16">
      <div className="overline mb-3">Doctors, Clinics & Hospitals</div>
      <h1 className="font-serif text-4xl md:text-5xl text-[#F3E9EC]">Partner With MediPats</h1>
      <p className="mt-4 text-[#F3E9EC]/70">Join our vetted network and reach international patients.</p>
      <div className="mt-10 mp-card p-8 space-y-4">
        <input className="mp-input" placeholder="Organisation / doctor name *" value={form.org_name} onChange={e=>set("org_name",e.target.value)} data-testid="partner-name"/>
        <select className="mp-select" value={form.type} onChange={e=>set("type",e.target.value)} data-testid="partner-type">
          <option value="doctor">Doctor</option><option value="clinic">Clinic</option><option value="hospital">Hospital</option>
        </select>
        <input className="mp-input" placeholder="Specialty" value={form.specialty} onChange={e=>set("specialty",e.target.value)}/>
        <input className="mp-input" placeholder="City" value={form.city} onChange={e=>set("city",e.target.value)}/>
        <div className="grid md:grid-cols-2 gap-4">
          <input className="mp-input" placeholder="Phone" value={form.phone} onChange={e=>set("phone",e.target.value)}/>
          <input className="mp-input" placeholder="Email *" value={form.email} onChange={e=>set("email",e.target.value)} data-testid="partner-email"/>
        </div>
        <input className="mp-input" placeholder="Website" value={form.website} onChange={e=>set("website",e.target.value)}/>
        <input className="mp-input" placeholder="Years of experience" value={form.experience} onChange={e=>set("experience",e.target.value)}/>
        <textarea className="mp-textarea min-h-[100px]" placeholder="Message" value={form.message} onChange={e=>set("message",e.target.value)}/>
        <button onClick={submit} disabled={!form.org_name || !form.email} className="btn-primary px-8 py-3 disabled:opacity-50" data-testid="partner-submit">Submit application</button>
      </div>
    </div>
  );
}
